export default __webpack_public_path__ + "static/media/servicetype_md.6efbeaeb.png";